var _style, _polyline, _polyline2, _polygon, _polyline3, _polyline4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgriwebbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 162 97",
    style: {
      enableBackground: "new 0 0 162 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#65BB38;}\n\t.st1{fill:#559F2F;}\n\t.st2{fill:#7BC555;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    className: "st0",
    points: "152.5,84.9 128.7,42.4 128.7,42.4 104.8,0 57.2,0 81,42.4 33.4,42.4 9.6,84.9 0,84.9 0,97 66.1,97 66.1,84.9 57.2,84.9 81,42.4 81,42.4 81,42.4 104.8,84.9 95.9,84.9 95.9,97 162,97 162,84.9 152.5,84.9 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-2",
    className: "st1",
    points: "33.4,42.4 81,42.4 57.2,84.9 33.4,42.4 "
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "st0",
    points: "57.2,0 81,42.4 128.7,42.4 104.8,0 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    className: "st2",
    points: "152.5,84.9 128.7,42.4 81,42.4 104.8,84.9 95.9,84.9 95.9,97 162,97 162,84.9 152.5,84.9 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    className: "st0",
    points: "57.2,84.9 33.4,42.4 9.6,84.9 0,84.9 0,97 66.1,97 66.1,84.9 57.2,84.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriwebbLogo);
export default __webpack_public_path__ + "static/media/agriwebb-logo.d784c79dccfe382ec150e57b9e3fcec0.svg";
export { ForwardRef as ReactComponent };